<script setup lang="ts">
/* eslint-disable max-len */
export interface IconTag {
  width?: number;
  height?: number;
  fill?: string;
}

const props = withDefaults(defineProps<IconTag>(), {
  width: 16,
  height: 16,
  fill: "#A9B7D1",
});
</script>

<template>
  <svg :width="props.width" :height="props.height" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.6 0a.8.8 0 0 1 .8.8v9.242a.8.8 0 0 1-.273.602l-5.598 5.158a.8.8 0 0 1-1.054 0l-5.602-5.158a.8.8 0 0 1-.273-.603V.801A.8.8 0 0 1 2.4 0zm-5 3.2H7.4v2.6H4.8V7h2.6v2.6h1.2V7h2.6V5.8H8.6V3.2z" :fill="props.fill" fill-rule="evenodd" />
  </svg>
</template>
